import { getEventTracker } from '@libs/eventTracking'
import {
  getNextPagePropertyFor,
  getCurrentPagePropertyFor,
} from '@libs/eventTracking/eventPropertyUtils'
import { WebEventNames } from './common'
import { paths } from '@routes/header-paths'

/**
 * [Link to spec](https://github.com/popdaily/popdaily.tracking/blob/develop/tracking_events/events/web-header/web-header.menu.enter-creator-dashboard.md)
 */
export function trackHeaderEnterCreatorDashboardEvent() {
  getEventTracker().track({
    name: WebEventNames.WEB_HEADER_MENU_ENTER_CREATOR_DASHBOARD,
    properties: {
      currentPage: getCurrentPagePropertyFor(''),
      toPage: getNextPagePropertyFor({
        pageName: 'creator-dashboard',
        pageUrl: window.location.origin + paths.creatorDashboard,
      }),
    },
  })
}
